export var unitPx = function unitPx(unit) {
  return "".concat(unit, "px");
};